// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"ace701f3","180":"8061ad6b","369":"bca261e5","374":"a5c5c26b","376":"8f37e549","534":"d4d1d970","719":"c885b339","866":"b08be247"}[chunkId] + ".chunk.js";
};